<article class="empty-message-container">
  <mat-icon>error_outline</mat-icon>
  <p>{{ translationKey | translate }}</p>
</article>
